<div class="menu-filtro" *ngFor="let item of menu" >
  <div *ngIf="item.children.length; else elseBlockNotHasChildren">
    <a
      data-toggle="collapse"
      href="#box{{ item.id }}"
      class="panel-heading {{ item.selected ? '' : 'collapsed' }}"
      (click)="selectAll()"
    >
      {{ item.description }}
    </a>
    <div
      id="box{{ item.id }}"
      class="box{{ item.id }} list-group list-group-flush panel-collapse collapse {{
        item.selected ? 'show' : ''
      }}"
    >
      <app-catalog-menu
        #submenu
        (onSelect)="onSelect($event)"
        *ngFor="let subItem of item.children"
        [item]="subItem"
        [selected]="subItem.selected || false" 
        [viewName]="item.description"
      ></app-catalog-menu>
    </div>
  </div>

  <ng-template #elseBlockNotHasChildren>
    <a
      (click)="selectRoot(item.id)"
      style="cursor: pointer"
      class="panel-heading-no-subtitle"
      >{{ item.description }}</a
    >
  </ng-template>
</div>

<hr *ngIf="menu" />
